module.exports = __webpack_public_path__ + "img/oah-promote.9a946e34.svg";